
import {Component}  from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState, MessageState} from "../../reducers"
import {MessageActions} from "../../actions"
import {Alert} from "../../ui-helper"
@Component({
	selector: 'messages',
	template: `

		<div *ngFor="let message of messages | async">
			<alert [type]="message.type" [visible]="true" (visibleChange)="hide(message.id)">
				{{message.message}}
			</alert>
		</div>
		`



})
export class MessagesComponent {
	public messages
	constructor(private store: Store<AppState>, private messageActions:MessageActions) {
		this.messages = store.select("messages").map(messageState => messageState.messages)
	}
	hide(id) {
		this.store.dispatch(this.messageActions.removeMessage(id))
	}
}


// WEBPACK FOOTER //
// ./src/app/components/messages/messages.component.ts